import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DataService } from '@services/ops-profiledata.service';
import { ContractorHeadCount } from '@interfaces/vendor-profile.model';
import { AuthService } from '@core/auth.service';
import { ActivatedRoute } from '@angular/router';
import { VendorProfile, vendorProfileMetrics } from '@app/shared/constants/global.enum';
import { generateLast12MonthsVendor, onMonthChange } from '@shared/utils/utils'
import { ToasterService } from '@services/toaster.service';

@Component({
  selector: 'app-contractor-vendor-head-count',
  templateUrl: './app-contractor-vendor-head-count.component.html',
  styleUrls: ['./app-contractor-vendor-head-count.component.scss'],
})
export class ContractorVendorHeadCountComponent implements OnInit {
  vendorProfile = VendorProfile;
  monthOptions: { value: string; label: string; month: string; year: string, selected?: boolean }[] = [];
  selectedMonth: string = '';
  selectedYear: string = '';
  totalCount: number = 0;
  isDataLoaded: boolean = false;
  errorMsg: string = '';
  displayData: ContractorHeadCount[] = [];
  vendorId: string | null = null;
  metrics: { label: string; key: keyof ContractorHeadCount }[] = [
    { label: vendorProfileMetrics.TotalContractors, key: 'totalContractors' },
    { label: vendorProfileMetrics.HyderabadContractors, key: 'hyderabadContractors' },
    { label: vendorProfileMetrics.NcrContractors, key: 'ncrContractors' },
    { label: vendorProfileMetrics.RemoteContractors, key: 'remoteContractors' },
  ];

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private toaster: ToasterService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.vendorId = params['vendorId'] || null;

      if (!this.vendorId) {
        this.toaster.showError(this.vendorProfile.vendorIdMissing, 'Error');
        return;
      }
    });

    this.monthOptions = generateLast12MonthsVendor();

    const preSelectedOption = this.monthOptions.find((option => option.selected));
    if (preSelectedOption) {
      this.selectedMonth = preSelectedOption.month;
      this.selectedYear = preSelectedOption.year;
    }
    if (this.vendorId) {
      this.loadVendorData();
    }
  }
  loadVendorData(): void {
    if (!this.vendorId) return;
    this.dataService
      .getContractorHeadCount(this.vendorId, this.selectedMonth, this.selectedYear)
      .subscribe({
        next: (response) => {
          this.displayData = response.data || [];
          this.totalCount = this.displayData.length;
          this.isDataLoaded = true;
          this.cdr.detectChanges();
        },
        error: () => {
      this.errorMsg = this.vendorProfile.failedToLoadContractorHeadCount;
          this.isDataLoaded = true;
          this.displayData = [];
          this.totalCount = 0;
      this.toaster.showError(this.vendorProfile.failedToLoadContractorHeadCount, 'Error');
          this.cdr.detectChanges();
        },
      });
  }

  onMonthChange(event: any): void {
    let selectedValue: string | undefined;
    if (typeof event === 'string') {
      const monthOption = this.monthOptions.find(option => option.label === event);
      selectedValue = monthOption ? monthOption.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }
    if (!selectedValue || !this.monthOptions.some(option => option.value === selectedValue)) {
      this.toaster.showError(this.vendorProfile.invalidMonthSelected, 'Error');
      return;
    }
    const selectedOption = this.monthOptions.find(option => option.value === selectedValue);
    if (selectedOption) {
      this.selectedMonth = selectedOption.month;
      this.selectedYear = selectedOption.year;
      this.loadVendorData();
    }
  }
}
